import { render, staticRenderFns } from "./CommentStep.vue?vue&type=template&id=5990807e"
import script from "./CommentStep.vue?vue&type=script&lang=js"
export * from "./CommentStep.vue?vue&type=script&lang=js"
import style0 from "./CommentStep.vue?vue&type=style&index=0&id=5990807e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports